import { render } from "./BenefitsAndInvestment.vue?vue&type=template&id=4fd11127&scoped=true"
import script from "./BenefitsAndInvestment.vue?vue&type=script&lang=js"
export * from "./BenefitsAndInvestment.vue?vue&type=script&lang=js"

import "./BenefitsAndInvestment.vue?vue&type=style&index=0&id=4fd11127&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd11127"]])

export default __exports__